import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { CurrencyWalletService } from 'src/app/layouts/currency-wallet/currency-wallet.service';
import { CurrenciesInterface } from 'src/app/shared/interfaces/deposit.interface';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { CSButtonComponent } from '../../cs-button/cs-button.component';
import { CSSelectComponent, ICSOption } from '../../cs-select/cs-select.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

export type FiatSelectorDialogData = { currencies: CurrenciesInterface[] };

export type FiatSelectorDialogResult = string;

@Component({
  selector: 'app-fiat-selector-dialog',
  standalone: true,
  imports: [CSButtonComponent, CSSelectComponent, PipesModule],
  templateUrl: './fiat-selector-dialog.component.html',
  styleUrl: './fiat-selector-dialog.component.scss',
})
export class FiatSelectorDialogComponent {
  constructor(
    private appService: AppService,
    private currencyWalletService: CurrencyWalletService,
    protected dialogRef: MatDialogRef<FiatSelectorDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) protected data: FiatSelectorDialogData,
    private toast: ToastService,
    private localeService: LocaleService,
  ) {
    this.currentFiat = this.currencyWalletService.inFiatConvertType$.value;
    this.fiatOptions = this.appService.currencies$.value
      .filter(v => v.isVisible && v.isDigital === false)
      .reduce((curr, item) => {
        const label = item.name;
        const value = item.currency;
        const img = item.icon;
        curr.push({ label, value, img });
        return curr;
      }, [] as ICSOption[]);
  }

  /** 當前币种類型 */
  protected currentFiat: string;

  /** 可選币种類型選項 */
  protected fiatOptions: ICSOption[] = [];

  protected onSave(): void {
    this.currencyWalletService.inFiatConvertType$.next(this.currentFiat);
    this.currencyWalletService.updateConversionCurrency();
    this.toast.show({
      message: this.localeService.getValue('fiat_currency_changed_to', this.currentFiat),
      duration: 3000,
      type: 'success',
    });
    this.dialogRef.close();
  }
}
